import React from "react";

export const Sandbox = () => {
  return (
    <span style={{
      zIndex: 20000,
      display: "block",
      position: "fixed",
      top: "0px",
      background: "#fcd539",
      color: "#464dee",
      padding: "10px",
      borderBottomRightRadius: "10px",
      fontWeight: "bold",
      fontSize: "20px",
      opacity: 0.8,
    }}>DEMO</span>
  );
};